var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4444 0C12.6303 0 11.0204 0.824135 10 2.10361C8.97963 0.824135 7.36957 0 5.55556 0C2.49441 0 0 2.36382 0 5.31325C0 8.26265 2.38099 10.6048 4.53515 12.7084C7.36961 15.4843 3.85483 12.0144 10 18C16.1451 12.0145 12.6304 15.4627 15.4649 12.7084C17.619 10.6048 20 8.24096 20 5.31325C20 2.38546 17.5056 0 14.4444 0Z",
    fill: "#D02424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a6d9b5f5cd7844a5bfc6aeb904d1c01f.svg";
export { ForwardRef as ReactComponent };